import { MDXProvider } from "@mdx-js/react";
import React from "react";

import DefaultLayout from "./default";

export default function MdxLayout({ children }: { children: React.ReactNode }) {
  // Create any shared layout or styles here
  return (
    <DefaultLayout>
      <MDXProvider
        components={{
          h1: (props) => (
            <h1 className="font-bold text-xl text-center mb-4" {...props} />
          ),
          h2: (props) => <h2 className="font-semibold text-lg" {...props} />,
          h3: (props) => <h3 className="font-semibold text-md" {...props} />,
          ul: (props) => {
            const childCount = React.Children.count(
              React.Children.toArray(props.children).filter(
                React.isValidElement,
              ),
            );

            return (
              <ul
                className={`custom-list pl-10 space-y-2 list-none ${childCount > 1 ? "multi-item" : ""}`}
                {...props}
              >
                {React.Children.map(props.children, (child) => {
                  if (React.isValidElement(child)) {
                    // Safely merge the new className with any existing ones
                    const existingClassName = child.props.className || "";
                    const newClassName = `pl-0 relative ${childCount > 1 ? "before:absolute before:left-[-2rem] before:top-[2px] before:w-5 before:h-5 before:bg-primary before:bg-opacity-10 before:rounded-full before:flex before:items-center before:justify-center before:text-sm before:font-semibold" : ""}`;

                    return React.cloneElement(child, {
                      ...child.props,
                      className: `${existingClassName} ${newClassName}`.trim(),
                    });
                  }

                  return child;
                })}
              </ul>
            );
          },
          ol: (props) => (
            <ol
              className="list-decimal font-semibold pl-6 mt-4 mb-2 space-y-2"
              {...props}
            />
          ),
        }}
      >
        <div className="container m-auto  p-4 font-light max-w-[100ch]">
          {children}
        </div>
      </MDXProvider>
    </DefaultLayout>
  );
}
